import { createSelector } from "reselect";
import { sortPromotions } from "../types/sortPromotions";
import { getPromotionsSummary } from "./getPromotionsSummary";

export const getSortedPromotions = createSelector(getPromotionsSummary, (list) => (list ? sortPromotions(list) : []));
